import { useState } from 'react'
import { Button_Main } from '../components/Button'
import Pagenation from '../components/Pagenation'
import Table from '../components/Table'
import { Main } from '../styles/layout'
import { Table_Info } from '../styles/table'
import { useGetGroupList } from '../api/main'
import { useLocation } from 'react-router'
import { Dialog } from '../components/Dialog'
import { GroupCreateForm, GroupUpdateForm } from '../components/Form'
import SearchForm, { DefaultParamKeys } from '../components/Search'
import { useAuthCheck } from '../hook'

export const GroupPage = () => {
  const location = useLocation()
  const { checkAuth } = useAuthCheck()
  const [isCreateOpen, setIsCreateOpen] = useState(false)
  const [isUpdateOpen, setIsUpdateOpen] = useState(false)
  const [updateModalKey, setUpdateModalKey] = useState('')
  const { data, isLoading, isError } = useGetGroupList(location.search)

  const openUpdateModal = (value:string) =>{
    setUpdateModalKey(value)
    setIsUpdateOpen(true)
  }
  return (
    <Main>
      <h1>그룹 관리</h1>
      {checkAuth('1100') && <SearchForm searchList={searchList}/>}
      <Table_Info>
        Total Count: {data?.total}
        <Button_Main onClick={() => setIsCreateOpen(true)}>등록</Button_Main>
      </Table_Info>
      <Table headers={headers} data={data?.data} isLoading={isLoading} isError={isError} rowKey={headers[1].value} modalKey={"groupId"} onClick={openUpdateModal}/>
      <Pagenation totalPage={data?.totalPage} isLoading={isLoading}/>

      <Dialog $isOpen={isCreateOpen} onClose={() => setIsCreateOpen(false)}>
        {isCreateOpen && <GroupCreateForm onClose={() => setIsCreateOpen(false)} />}
      </Dialog>
      <Dialog $isOpen={isUpdateOpen} onClose={() => setIsUpdateOpen(false)}>
        {isUpdateOpen && <GroupUpdateForm data={updateModalKey} onClose={() => setIsUpdateOpen(false)} />}
      </Dialog>
    </Main>
  )
}


const headers = [
  { value: 'partName', label: '소속' },
  { value: 'groupName', label: '그룹' },
  { value: 'createdDate', label: '등록일' },
  { value: 'updatedDate', label: '수정일' },
  { value: 'groupDesc', label: '비고' }
]

const searchList:DefaultParamKeys[] = [
  'partName',
  'groupName'
]
